export default __webpack_public_path__ + "static/media/Linero5Closed.0945efa0.jpg";